export default function Datenschutz() {
  return (
    <div className="bg-white">
      <div className="max-w-3xl mx-auto px-6 lg:px-12 py-16 lg:py-24">
        <p className="text-xs font-bold tracking-[0.25em] uppercase text-[#FF5A00] mb-3">RECHTLICHES</p>
        <h1 className="text-4xl sm:text-5xl font-black tracking-tighter mb-4" data-testid="datenschutz-title">Datenschutzerklärung</h1>
        <p className="text-sm text-neutral-500 mb-12">Stand: Februar 2026 · Geltungsbereich: www.talkani.de</p>

        <Section title="1. Verantwortlicher">
          <p>Verantwortlich für die Datenverarbeitung auf dieser Website im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:</p>
          <p className="font-bold mt-3">Talkani Logistik &amp; Reinigung GmbH i.&nbsp;Gr.</p>
          <p>Walddörferstraße 383<br/>22047 Hamburg<br/>Deutschland</p>
          <p className="mt-3">Vertreten durch den Gründungsgesellschafter: Ali Al-Talkani</p>
          <p className="mt-3">Telefon: <a href="tel:+491758802646" className="text-[#FF5A00] hover:underline">+49 175 8802646</a><br/>E-Mail: <a href="mailto:info@talkani.de" className="text-[#FF5A00] hover:underline">info@talkani.de</a></p>
        </Section>

        <Section title="2. Allgemeines zur Datenverarbeitung">
          <p>Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies zur Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und Leistungen erforderlich ist. Die Verarbeitung personenbezogener Daten unserer Nutzer erfolgt regelmäßig nur nach Einwilligung des Nutzers oder soweit dies nach Art. 6 Abs. 1 DSGVO gesetzlich gestattet ist.</p>
        </Section>

        <Section title="3. Bereitstellung der Website und Erstellung von Logfiles">
          <p>Bei jedem Aufruf unserer Website erfasst unser System automatisiert Daten und Informationen vom Computersystem des aufrufenden Rechners.</p>
          <p className="mt-3">Folgende Daten werden hierbei erhoben:</p>
          <ul className="list-disc list-inside mt-2 space-y-1 text-neutral-700">
            <li>IP-Adresse des Nutzers (gekürzt/anonymisiert)</li>
            <li>Datum und Uhrzeit des Zugriffs</li>
            <li>Browsertyp und verwendete Version</li>
            <li>Betriebssystem</li>
            <li>Referrer-URL (zuvor besuchte Seite)</li>
          </ul>
          <p className="mt-3"><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an Stabilität und Sicherheit der Website).</p>
          <p className="mt-2"><strong>Speicherdauer:</strong> Logdaten werden nach 7 Tagen automatisch gelöscht oder anonymisiert.</p>
        </Section>

        <Section title="4. Buchungsformular und Nutzerkonto">
          <p>Wenn Sie ein Konto über "Mit Google anmelden" anlegen oder eine Buchung vornehmen, verarbeiten wir folgende Daten:</p>
          <ul className="list-disc list-inside mt-2 space-y-1 text-neutral-700">
            <li>Name und E-Mail-Adresse (aus Ihrem Google-Profil)</li>
            <li>Profilbild-URL (aus Ihrem Google-Profil)</li>
            <li>Telefonnummer und Lieferadresse (von Ihnen eingegeben)</li>
            <li>Buchungsdaten (gewählter Service, Datum, Uhrzeit, Details)</li>
          </ul>
          <p className="mt-3"><strong>Zweck:</strong> Erfüllung des Vertrages (Durchführung des gebuchten Service) sowie Kommunikation mit Ihnen.</p>
          <p className="mt-2"><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung).</p>
          <p className="mt-2"><strong>Speicherdauer:</strong> Buchungsdaten werden für die Dauer der gesetzlichen Aufbewahrungsfristen (i.d.R. 10 Jahre nach § 147 AO) aufbewahrt. Account-Daten können auf Anfrage jederzeit gelöscht werden.</p>
        </Section>

        <Section title="5. Kontaktformular">
          <p>Wenn Sie uns über das Kontaktformular eine Nachricht senden, verarbeiten wir die von Ihnen mitgeteilten Daten (Name, E-Mail-Adresse, Telefonnummer, Betreff, Nachrichtentext) zur Bearbeitung Ihrer Anfrage.</p>
          <p className="mt-3"><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b und f DSGVO.</p>
          <p className="mt-2"><strong>Speicherdauer:</strong> Bis zur Erledigung Ihrer Anfrage, danach max. 6 Monate, sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen.</p>
        </Section>

        <Section title="6. Cookies und Local Storage">
          <p>Unsere Website verwendet ausschließlich <strong>technisch notwendige Cookies und Speicherelemente</strong>:</p>
          <ul className="list-disc list-inside mt-2 space-y-1 text-neutral-700">
            <li><strong>session_token</strong> (HttpOnly Cookie): zur Aufrechterhaltung Ihrer Anmeldung — gültig 7 Tage</li>
            <li><strong>talkani_lang</strong> (Local Storage): zur Speicherung Ihrer gewählten Sprache (DE/EN/AR)</li>
          </ul>
          <p className="mt-3"><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO. Diese Cookies sind technisch erforderlich; eine Einwilligung ist nicht notwendig.</p>
          <p className="mt-2">Wir verwenden <strong>keine Tracking-, Werbe- oder Analyse-Cookies</strong> ohne Ihre ausdrückliche Einwilligung.</p>
        </Section>

        <Section title="7. Einsatz von Auftragsverarbeitern und Drittanbietern">
          <p>Zur Bereitstellung unserer Dienste setzen wir folgende Auftragsverarbeiter ein. Mit allen Anbietern bestehen Auftragsverarbeitungsverträge gemäß Art. 28 DSGVO:</p>
          <div className="mt-3 space-y-3">
            <SubItem name="Google LLC (Google Sign-In)">
              Single Sign-On über OAuth. Verarbeitet Ihre E-Mail, Ihren Namen und Ihr Profilbild zum Zwecke der Anmeldung.
              Datenschutz: <a href="https://policies.google.com/privacy" className="text-[#FF5A00] hover:underline" target="_blank" rel="noreferrer">policies.google.com/privacy</a>
            </SubItem>
            <SubItem name="Resend Inc. (E-Mail-Versand)">
              Versand von Buchungsbestätigungen und Benachrichtigungen. Sitz: USA. Auftragsverarbeitung gemäß EU-Standardvertragsklauseln.
              Datenschutz: <a href="https://resend.com/legal/privacy-policy" className="text-[#FF5A00] hover:underline" target="_blank" rel="noreferrer">resend.com/legal/privacy-policy</a>
            </SubItem>
            <SubItem name="Stripe Payments Europe Ltd. (Zahlungsabwicklung)">
              Sofern Online-Zahlung gewählt wird, werden Zahlungsdaten direkt an Stripe übermittelt. Wir selbst speichern keine Kreditkartendaten.
              Datenschutz: <a href="https://stripe.com/de/privacy" className="text-[#FF5A00] hover:underline" target="_blank" rel="noreferrer">stripe.com/de/privacy</a>
            </SubItem>
            <SubItem name="MongoDB (Datenbankhosting)">
              Speicherung von Buchungs- und Kundendaten auf EU-Servern. Datenschutz: <a href="https://www.mongodb.com/legal/privacy-policy" className="text-[#FF5A00] hover:underline" target="_blank" rel="noreferrer">mongodb.com/legal/privacy-policy</a>
            </SubItem>
            <SubItem name="Hosting-Anbieter">
              Die Website wird auf Servern innerhalb der Europäischen Union gehostet.
            </SubItem>
          </div>
        </Section>

        <Section title="8. Datenübermittlung in Drittländer">
          <p>Eine Übermittlung Ihrer personenbezogenen Daten an Stellen außerhalb der EU/des EWR (z.B. an Google oder Resend in den USA) erfolgt nur auf Grundlage geeigneter Garantien gemäß Art. 46 DSGVO (EU-Standardvertragsklauseln, Angemessenheitsbeschluss).</p>
        </Section>

        <Section title="9. Ihre Rechte als betroffene Person">
          <p>Nach der DSGVO stehen Ihnen folgende Rechte zu:</p>
          <ul className="list-disc list-inside mt-2 space-y-1 text-neutral-700">
            <li><strong>Recht auf Auskunft</strong> (Art. 15 DSGVO) — welche Daten wir über Sie gespeichert haben</li>
            <li><strong>Recht auf Berichtigung</strong> (Art. 16 DSGVO) — bei unrichtigen Daten</li>
            <li><strong>Recht auf Löschung</strong> (Art. 17 DSGVO) — "Recht auf Vergessenwerden"</li>
            <li><strong>Recht auf Einschränkung der Verarbeitung</strong> (Art. 18 DSGVO)</li>
            <li><strong>Recht auf Datenübertragbarkeit</strong> (Art. 20 DSGVO)</li>
            <li><strong>Widerspruchsrecht</strong> (Art. 21 DSGVO) gegen Verarbeitung aus berechtigtem Interesse</li>
            <li><strong>Widerruf der Einwilligung</strong> (Art. 7 Abs. 3 DSGVO) jederzeit mit Wirkung für die Zukunft</li>
          </ul>
          <p className="mt-3">Zur Ausübung Ihrer Rechte genügt eine formlose E-Mail an: <a href="mailto:info@talkani.de" className="text-[#FF5A00] hover:underline font-semibold">info@talkani.de</a></p>
        </Section>

        <Section title="10. Beschwerderecht bei der Aufsichtsbehörde">
          <p>Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren. Zuständig ist:</p>
          <p className="mt-2 font-semibold">Der Hamburgische Beauftragte für Datenschutz und Informationsfreiheit</p>
          <p>Ludwig-Erhard-Straße 22, 7. OG · 20459 Hamburg</p>
          <p>Telefon: 040 / 428 54 - 4040 · E-Mail: mailbox@datenschutz.hamburg.de</p>
        </Section>

        <Section title="11. Datensicherheit">
          <p>Wir verwenden auf unserer Website durchgehend das TLS/SSL-Verschlüsselungsverfahren (HTTPS), um die Übertragung Ihrer Daten zu schützen. Passwörter werden niemals im Klartext gespeichert. Der Zugriff auf personenbezogene Daten ist auf autorisierte Mitarbeiter beschränkt.</p>
        </Section>

        <Section title="12. Änderungen dieser Datenschutzerklärung">
          <p>Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen umzusetzen. Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung.</p>
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="mb-10">
      <h2 className="text-lg font-bold tracking-tight mb-3 text-neutral-900">{title}</h2>
      <div className="text-base text-neutral-700 leading-relaxed">{children}</div>
    </section>
  );
}

function SubItem({ name, children }) {
  return (
    <div className="border-l-2 border-[#FF5A00] ps-4 py-1">
      <p className="font-bold text-sm">{name}</p>
      <p className="text-sm text-neutral-600 mt-1 leading-relaxed">{children}</p>
    </div>
  );
}
